import { render, staticRenderFns } from "./MEMO.vue?vue&type=template&id=4c6e4a4b&scoped=true"
import script from "./MEMO.vue?vue&type=script&lang=js"
export * from "./MEMO.vue?vue&type=script&lang=js"
import style0 from "./MEMO.vue?vue&type=style&index=0&id=4c6e4a4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6e4a4b",
  null
  
)

export default component.exports